import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper } from '../../../utils';

export const BindersIllustration = ({ width = 40, marginLeft, marginRight, containerSize }: DefaultIconProps) => (
  <DefaultIconWrapper marginLeft={marginLeft} marginRight={marginRight} containerSize={containerSize} width={width}>
    <svg width="162" height="170" viewBox="0 0 162 170" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Pictogram">
        <path id="Binder left" fillRule="evenodd" clipRule="evenodd" d="M0 170H45.5339V3.93359H0V170Z" fill="#FFBF00" />
        <path
          id="Binder middle"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M45.5352 170H91.0611V3.93359H45.5352V170Z"
          fill="#ED585D"
        />
        <path
          id="Binder right"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M161.999 164.018L117.03 170L91.0586 7.12814L136.027 0L161.999 164.018Z"
          fill="#6AB3A9"
        />
        <path
          id="Tag left"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.98828 65.2447H35.5645V19.2656H9.98828V65.2447Z"
          fill="white"
        />
        <path
          id="Lines left"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.96484 34.5884H35.5411V29.4805H9.96484V34.5884ZM9.96484 44.8081H35.5411V39.7002H9.96484V44.8081ZM35.5411 55.024H9.96484V49.9161H35.5411V55.024Z"
          fill="#DADADA"
        />
        <path
          id="Tag middle"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M56.1484 65.2447H81.7207V19.2656H56.1484V65.2447Z"
          fill="white"
        />
        <path
          id="Lines middle"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M56.125 34.5884H81.7012V29.4805H56.125V34.5884ZM56.125 44.8081H81.7012V39.7002H56.125V44.8081ZM81.7012 55.024H56.125V49.9161H81.7012V55.024Z"
          fill="#DADADA"
        />
        <path
          id="Tag right"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M136.389 60.8708L111.129 64.8757L103.938 19.458L129.202 15.4531L136.389 60.8708Z"
          fill="white"
        />
        <path
          id="Lines right"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M131.574 30.5954L106.314 34.6003L105.516 29.5557L130.776 25.5508L131.574 30.5954ZM133.171 40.6879L107.911 44.6928L107.113 39.6481L132.373 35.6432L133.171 40.6879ZM109.509 54.7849L134.773 50.78L133.975 45.7353L108.711 49.7402L109.509 54.7849Z"
          fill="#DADADA"
        />
        <path
          id="Circles"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M138.541 156.222C145.507 155.119 150.256 148.576 149.154 141.61C148.051 134.644 141.508 129.888 134.55 130.991C127.584 132.098 122.834 138.641 123.937 145.607C125.039 152.573 131.582 157.329 138.541 156.222ZM35.5406 146.988C35.5406 154.045 29.8271 159.762 22.7782 159.762C15.7252 159.762 10.0078 154.045 10.0078 146.988C10.0078 139.935 15.7252 134.219 22.7782 134.219C29.8271 134.219 35.5406 139.935 35.5406 146.988ZM81.6972 146.988C81.6972 154.045 75.9837 159.762 68.9347 159.762C61.8778 159.762 56.1644 154.045 56.1644 146.988C56.1644 139.935 61.8778 134.219 68.9347 134.219C75.9837 134.219 81.6972 139.935 81.6972 146.988Z"
          fill="white"
        />
        <path
          id="Shadow left"
          opacity="0.1"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M22.7617 170H45.5286V3.9375H22.7617V170Z"
          fill="#1D1D1B"
        />
        <path
          id="Shadow middle"
          opacity="0.1"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M68.293 170H91.0599V3.9375H68.293V170Z"
          fill="#1D1D1B"
        />
        <path
          id="Shadow right"
          opacity="0.1"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M162.001 164.018L140.154 166.924L113.543 3.56605L136.029 0L162.001 164.018Z"
          fill="#1D1D1B"
        />
      </g>
    </svg>
  </DefaultIconWrapper>
);
